export const Program = {
  HCA: 'HCA',
  MHAW: 'MHAW',
  NonHCAP: 'Non-HCAP',
  Unknown: 'Unknown',
};
